<template>
  <div class="consultationEdit">
    <el-dialog
      class="consultationEdit_dialog"
      :title="[null, undefined, ''].includes(form.id) ? '新增问诊单' : '编辑问诊单'"
      :visible.sync="visible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div class="basic">
          <el-form ref="form" class="form" :model="form" label-width="100px">
            <el-form-item class="form_item" label="问诊单名称" prop="templateName" :rules="[{ required: true, message: '请输入问诊单名称' }]">
              <el-input v-model="form.templateName" placeholder="请输入" maxlength="10" show-word-limit></el-input>
            </el-form-item>
            <el-form-item class="form_item" label="问诊单描述" prop="templateDescribe">
              <el-input v-model="form.templateDescribe" placeholder="请输入(非必填)"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="form.questions.length === 0" class="list_add" @click="toQuestionEdit()">
          <el-button class="list_add_btn" type="text" icon="el-icon-plus">新增题目</el-button>
        </div>
        <div v-if="form.questions.length > 0" class="list">
          <vuedraggable class="list_draggable" v-model="form.questions" :options="{ handle: '.item_btn_rank', animation: 400 }">
            <transition-group>
              <div v-for="(question, questionIndex) in form.questions" :key="question.vId" class="item">
                <div class="header">
                  <div class="header_title">
                    <div v-if="question.required" class="header_title_required">*</div>
                    <div class="header_title_text">{{ questionIndex + 1 }}.{{ question.questionsTitle }}</div>
                  </div>
                  <div class="header_operate">
                    <el-button type="text" icon="el-icon-rank" class="item_btn_rank"></el-button>
                    <el-popconfirm placement="top" title="是否确定删除该题目？" icon="el-icon-warning" icon-color="#FE8F1F" @confirm="delQuestions(question.vId)">
                      <el-button slot="reference" type="text" icon="el-icon-delete" class="item_btn_del"></el-button>
                    </el-popconfirm>
                    <el-button class="item_btn_edit" @click="toQuestionEdit(question.vId)">编辑</el-button>
                  </div>
                </div>
                <div v-if="question.questionDescribe" class="question_description">{{ question.questionDescribe }}</div>
                <div v-if="question.sampleImages.length > 0" class="question_example">
                  <img v-for="(exampleImg, exampleImgIndex) in question.sampleImages" :key="exampleImgIndex" class="question_example_img" :src="exampleImg">
                </div>
                <div class="answer">
                  <div v-if="question.questionsType === 0" class="answer_single">
                    <el-radio v-for="answer in question.answers" :key="answer.id" class="answer_single_radio" value="0" disabled>{{ answer.answerContent }}</el-radio>
                  </div>
                  <div v-if="question.questionsType === 1" class="answer_multiple">
                    <el-checkbox v-for="answer in question.answers" :key="answer.id" class="answer_single_checkbox" value="0" disabled>{{ answer.answerContent }}</el-checkbox>
                  </div>
                  <div v-if="question.questionsType === 4" class="answer_shortAnswer">
                    <div v-show="question.answerType.includes('1')" class="answer_shortAnswer_img">
                      <div class="answer_shortAnswer_img_header">
                        <div class="answer_shortAnswer_img_title">图片上传</div>
                        <div class="answer_shortAnswer_img_tips">限jpg/png文件，最多上传5张</div>
                      </div>
                      <div class="answer_shortAnswer_img_upload">
                        <span class="el-icon-plus answer_shortAnswer_upload_icon"></span>
                      </div>
                    </div>
                    <div v-show="question.answerType.includes('2')" class="answer_shortAnswer_text">
                      <el-input class="answer_shortAnswer_text_input" placeholder="请输入" disabled></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </vuedraggable>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="footer_left">
          <el-button v-if="form.questions.length > 0" type="text" icon="el-icon-plus" class="footer_btn_add" @click="toQuestionEdit()">新增题目</el-button>
        </div>
        <div class="footer_right">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="submit">保 存</el-button>
        </div>
      </div>
    </el-dialog>
    <QuestionEdit ref="questionEdit" @submit="questionEditSubmit"></QuestionEdit>
  </div>
</template>

<script>
  import vuedraggable from 'vuedraggable'
  import QuestionEdit from './questionEdit.vue'

  import { questionList } from '@/api/consultation-questionnaire'
  export default {
    name: 'consultationEdit',
    components: {
      vuedraggable,
      QuestionEdit
    }, 
    data () {
      return {
        visible: false,
        loading: false,
        id: null,
        form: {
          id: null,
          templateName: '',
          templateDescribe: '',
          questions: []
        }
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      async open (id = null) {
        this.visible = true
        if (id) {
          this.form.id = id
          this.loading = true
          const res = await questionList({ inquiryTemplateId: id })
          this.loading = false
          if (res.code == 200) {
            this.form.templateName = res.data.templateName || ''
            this.form.templateDescribe = res.data.templateDescribe || ''
            this.form.questions = res.data.questions && res.data.questions.map(v => {
              v['vId'] = this.generateUUID()
              v.answerType = [null, undefined, ''].includes(v.answerType) ? [] : v.answerType.split(',')
              v.sampleImages = [null, undefined, ''].includes(v.sampleImages) ? [] : v.sampleImages.split(',')
              return v
            }) || []
          }
        }
      },
      close () {
        this.form.id = null
        this.form.templateName = ''
        this.form.templateDescribe = ''
        this.form.questions = []
        this.$refs['form'].resetFields()
        this.visible = false
      },
      toQuestionEdit (vId) {
        const info = {
          vId: vId || null,
          id: null,
          questionsType: 0,
          required: 1,
          questionsTitle: '',
          questionDescribe: '',
          answers: [],
          sampleImages: [],
          answerType: []
        }
        const question = this.form.questions.find(v => v.vId === vId)
        if (question) {
          info.id = question.id
          info.questionsType = [null, undefined, ''].includes(question.questionsType) ? 0 : question.questionsType
          info.required = [null, undefined, ''].includes(question.required) ? 1 : question.required
          info.questionsTitle = question.questionsTitle
          info.questionDescribe = question.questionDescribe
          info.answers = question.answers || []
          info.sampleImages = question.sampleImages || []
          info.answerType = question.answerType || []
        }
        this.$refs['questionEdit'].open(info)
      },
      delQuestions (vId) {
        const index = this.form.questions.findIndex(v => v.vId === vId)
        if (index > -1) {
          this.form.questions.splice(index, 1)
        }
      },
      questionEditSubmit (info) {
        if ([null, undefined, ''].includes(info.vId)) {
          info.vId = this.generateUUID()
          this.form.questions.push(info)
        } else {
          const quuestion = this.form.questions.find(v => v.vId === info.vId)
          if (quuestion) {
            quuestion.vId = info.vId
            quuestion.id = info.id
            quuestion.questionsType = info.questionsType
            quuestion.required = info.required
            quuestion.questionsTitle = info.questionsTitle
            quuestion.questionDescribe = info.questionDescribe
            quuestion.answers = info.answers
            quuestion.sampleImages = info.sampleImages
            quuestion.answerType = info.answerType
          }
        }
      },
      submit () {
        this.$refs['form'].validate(valid => {
          if (valid) {
            const info = JSON.parse(JSON.stringify(this.form))
            info.questions.map(v => {
              v.sampleImages = v.sampleImages.join(',')
              v.answerType = v.answerType.join(',')
            })
            this.$emit('submit', info)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .consultationEdit_dialog /deep/ .el-dialog {
    border-radius: 4px;
  }
  .consultationEdit_dialog /deep/ .el-dialog__header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    height: 48px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .consultationEdit_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .consultationEdit_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  .consultationEdit_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .consultationEdit_dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    box-sizing: border-box;
    padding: 20px 24px;
    width: 100%;
    max-height: 600px;
    background-color: #F9F9FA;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .basic {
    width: 100%;
    overflow: hidden;
  }

  .form {
    width: 100%;
    overflow: hidden;
  }

  .form_item {
    margin-bottom: 20px;
  }

  .form_item /deep/ .el-form-item__label {
    line-height: 32px;
    font-size: 14px;
    color: #667182;
  }

  .form_item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .list_add {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
    border: 1px dashed #E0E0E0;
    border-radius: 2px;
    cursor: pointer;
  }

  .list_add_btn {
    font-size: 14px;
    color: #1890FF;
  }

  .list {
    width: 100%;
  }

  .item {
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);
    border-radius: 4px;
  }

  .item+.item {
    margin: 16px 0 0 0;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  .header_title {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2px 0 0 0;
    width: 485px;
  }

  .header_title_required {
    line-height: 20px;
    font-size: 14px;
    color: #F54A45;
  }

  .header_title_text {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .header_operate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .item_btn_rank {
    padding: 0;
    font-size: 18px;
    color: #667182;
  }

  .item_btn_rank:hover {
    color: #1890FF;
  }

  .item_btn_del {
    margin: 0 0 0 16px;
    padding: 0;
    font-size: 18px;
    color: #667182;
  }

  .item_btn_del:hover {
    color: #1890FF;
  }

  .item_btn_edit {
    box-sizing: border-box;
    margin: 0 0 0 16px;
    padding: 0 10px;
    height: 28px;
    line-height: 26px;
  }

  .question_description {
    margin: 8px 0 0 0;
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    color: #505050;
    white-space: pre-wrap;
  }

  .question_example {
    margin: 8px -12px -12px 0;
    width: 100%;
  }

  .question_example_img {
    margin: 0 12px 12px 0;
    width: 80px;
    height: 80px;
  }

  .answer {
    margin: 8px 0 0 0;
    width: 100%;
  }

  .answer_single {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_single_radio {
    margin: 0;
    line-height: 20px;
    white-space: wrap;
    word-break: break-all;
  }
  
  .answer_single_radio+.answer_single_radio {
    margin: 12px 0 0 0;
  }

  .answer_multiple {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_single_checkbox {
    margin: 0;
    line-height: 20px;
    white-space: normal;
    word-break: break-word;
  }

  .answer_single_checkbox /deep/ .el-checkbox__label {
    display: inline;
  }

  .answer_single_checkbox+.answer_single_checkbox {
    margin: 12px 0 0 0;
  }

  .answer_shortAnswer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_shortAnswer_img {
    margin: 0 0 0 0;
  }

  .answer_shortAnswer_img_header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .answer_shortAnswer_img_title {
    line-height: 18px;
    font-size: 14px;
    color: #323233;
  }

  .answer_shortAnswer_img_tips {
    margin: 0 0 0 6px;
    line-height: 18px;
    font-size: 12px;
    color: #606266;
  }

  .answer_shortAnswer_img_upload {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 0 0;
    width: 148px;
    height: 148px;
    background-color: #F9F9FA;
    border: 1px dashed #DCDFE6;
    border-radius: 6px;
  }

  .answer_shortAnswer_upload_icon {
    font-size: 28px;
    color: #303133;
  }

  .answer_shortAnswer_text {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .answer_shortAnswer_text_input {
    width: 100%;
  }

  .answer_shortAnswer_text_input.is-disabled /deep/ .el-input__inner {
    background-color: #F9F9FA;
    border-color: #D3D3D5;
  }

  .footer {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 56px;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
  }

  .footer_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .footer_btn_add {
    font-size: 14px;
    color: #1890FF;
  }

  .footer_right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>